<template>
    <v-container :fluid="$vuetify.breakpoint.md">
        <v-row justify="center">
            <v-col cols="12" md="11">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-0"
                                  style="word-break: normal">PAGO Nº {{ id.length < 5 ? ('0000' + id).slice(-4) : id }}
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="11">
                <v-card>
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-2" style="word-break: normal">ESTADO: {{ payment.status_name ? payment.status_name.toUpperCase() : '' }}
                    </v-card-title>
                    <v-divider/>
                    <v-card-text>
                        <v-row justify="center">
                            <v-col cols="12" class="py-2">
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h2 class="text-center" v-else>Servicio: {{ service.name }}</h2>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" class="py-2">
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.td + ': ' + user.td }}</h4>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.nd + ': ' + user.nd }}</h4>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.name + ': ' + user.name }}</h4>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.lname + ': ' + user.lname }}</h4>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.email + ': ' + user.email }}</h4>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h4 class="text-center" v-else>{{ labels.phone + ': +57' + user.phone }}</h4>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-skeleton-loader class="mx-auto" width="100%" type="table-heading" v-if="loading === true"/>
                                <v-simple-table dense v-else>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th colspan="2">
                                                <h2 class="text-center">
                                                    <strong>Información de Pago</strong>
                                                </h2>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="text-right" width="46%"><strong>Valor</strong></td>
                                            <td class="text-left" width="54%">{{ Number(payment.base).toLocaleString("en-US") }} {{ payment.currency }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right"><strong>I.V.A</strong></td>
                                            <td class="text-left">{{ Number(payment.tax).toLocaleString("en-US") }} {{ payment.currency }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right"><strong>Total</strong></td>
                                            <td class="text-left">{{ Number(payment.amount).toLocaleString("en-US") }} {{ payment.currency }}</td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" v-if="payment.status > 201">
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h3 class="text-center" v-else>Tipo de Pago: {{ payment.type }}</h3>
                                <v-skeleton-loader class="mx-auto" width="100%" type="list-item" v-if="loading === true"/>
                                <h3 class="text-center" v-else>Fecha de Pago: {{ payment.date_pay }}</h3>
                            </v-col>
                        </v-row>
                        <v-form ref="bank" @submit.prevent="submit" lazy-validation v-model="valid" v-if="payment.status === 201">
                            <v-row justify="center">
                                <v-col cols="12" sm="6">
                                    <v-select
                                        :label="labels.Payment"
                                        :items="payments"
                                        name="Payment"
                                        v-model="form.Payment"
                                        :error-messages="errors.Payment"
                                        :disabled="loading"
                                        :rules="[rules.req('Payment')]"
                                        @select="clearErrors('Payment')"
                                        prepend-icon="mdi-chart-donut"
                                        filled>
                                        <template v-slot:selection="{ item }">
                                            <v-flex>
                                                <v-avatar size="28px" color="primary">
                                                    <v-icon class="white--text">mdi-{{ item.icon }}</v-icon>
                                                </v-avatar>
                                                <span class='ml-1'>{{ item.text }}</span>
                                            </v-flex>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <v-list-item-avatar color="primary">
                                                <v-icon class="white--text">mdi-{{ item.icon }}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="item.text"/>
                                            </v-list-item-content>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" class="text-center pt-1 pb-4" v-if="form.Payment === 'Banco'">
                                    <v-btn color="primary" dark @click="banks = true">
                                        <v-icon>mdi-bank</v-icon>&nbsp;&nbsp;Ver Cuentas Bancarias
                                    </v-btn>
                                    <v-dialog v-model="banks" scrollable max-width="800" width="80%">
                                        <v-card>
                                            <v-card-title class="text-center headline primary white--text d-inline-block" style="word-break: normal; width: 100%">Cuentas Bancarias</v-card-title>
                                            <v-card-text>
                                                <v-row justify="center">
                                                    <v-col cols="12" md="10" class="py-4">
                                                        <h2 class="text-center">Vapp Colombia S.A.S.</h2>
                                                        <h3 class="text-center">NIT 900.934.177-8</h3>
                                                    </v-col>
                                                    <template v-for="(item, index) in accounts">
                                                        <v-col cols="12" md="10" :class="index < accounts.length - 1 ? 'pb-0' : ''">
                                                            <v-card flat rounded color="transparent" link class="pa-4" @click="copyText(item.number)">
                                                                <h3 class="text-center">{{ item.bank }}</h3>
                                                                <v-divider/>
                                                                <h4 class="text-center">Tipo de Cuenta: {{ item.type  }}</h4>
                                                                <h4 class="text-center">Número de Cuenta: {{ item.number  }}</h4>
                                                            </v-card>
                                                        </v-col>
                                                    </template>
                                                </v-row>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn color="error" @click="banks = false"><v-icon>mdi-close-circle</v-icon>Cerrar</v-btn>
                                                <v-spacer/>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="form.Payment === 'Banco'">
                                    <v-file-input
                                        :label="labels.Voucher"
                                        v-model="form.Voucher"
                                        name="Voucher"
                                        accept="image/*"
                                        :error-messages="errors.Voucher"
                                        :rules="[rules.req('Voucher')]"
                                        :disabled="loading"
                                        prepend-icon="mdi-camera"
                                        @input="clearErrors('Voucher')"
                                        @click:clear="clearVoucher"
                                        show-size counter filled/>
                                </v-col>
                                <v-col cols="6" sm="5" md="4" lg="3" v-if="imageData !== null">
                                    <img :src="imageData" width="100%" alt="voucher" style="border: 1px solid #eee; border-radius: 4px;"/>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row justify="center">
                            <v-col cols="6" md="5" lg="4" class="text-center py-6">
                                <v-btn style="height: 40px" color="error" dark to="/payments">
                                    <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;Volver
                                </v-btn>
                            </v-col>
                            <v-col cols="6" md="5" lg="4" class="text-center py-6" v-if="payment.voucher && payment.status > 201">
                                <v-btn style="height: 40px" color="primary" dark @click="view = true">
                                    <v-icon>mdi-image-area</v-icon>&nbsp;&nbsp;Voucher
                                </v-btn>
                            </v-col>
                            <v-col cols="6" md="5" lg="4" class="text-center py-6" v-if="payment.status === 201">
                                <form ref="wompi" v-show="form.Payment === 'Wompi'"></form>
                                <v-btn style="height: 40px" color="primary" dark @click="submit" v-if="form.Payment !== 'Wompi'">
                                    <v-icon>mdi-cash</v-icon>&nbsp;&nbsp;Pagar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-dialog v-model="view" scrollable max-width="1000" width="80%" v-if="payment.voucher">
                    <v-card>
                        <v-card-title class="text-center headline primary white--text d-inline-block" style="color: #ffffff; word-break: normal; width: 100%">Comprobante # {{ id }}</v-card-title><v-card-text>
                            <img :src="'/' + payment.voucher" :alt="id" width="100%"/>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="error" @click="view = false"><v-icon>mdi-close-circle</v-icon> Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../helpers/form";

    export default {
        name: "PaymentView",
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            id: null,
            loading: true,
            labels: {
                td: 'Tipo de Documento',
                nd: 'Número de Documento',
                name: 'Nombre(s)',
                lname: 'Apellido(s)',
                email: 'Correo Electrónico',
                phone: 'Telefono',
                Payment: 'Forma de Pago',
                Voucher: 'Foto del Voucher'
            },
            payments: [
                { text: 'Tarjeta de Crédito/Debito - PSE', value: 'Wompi', icon: 'credit-card' },
                { text: 'Deposito/Transferencia', value: 'Banco', icon: 'bank-transfer' },
                //{ text: 'Boton Nequi', value: 'Nequi', icon: 'wallet' }
            ],
            payment: {},
            service: {},
            form: {
                Payment: null,
                Voucher: null,
            },
            banks: false,
            accounts: [],
            imageData: null,
            wompi: {
                public: '',
                signature: ''
            },
            view: false
        }),
        created() {
            this.id = this.$route.params.id;
        },
        mounted() {
            this.getData();
        },
        watch: {
            'form.Voucher'() {
                if (this.form.Voucher) {
                    this.getVoucher();
                }
            }
        },
        methods: {
            getData() {
                clearTimeout(this.timeout);
                axios.get('/api/payments/view/' + this.id).then((res) => {
                    this.payment = res.data.payment;
                    this.service = res.data.service;
                    this.accounts = res.data.accounts;
                    this.wompi = res.data.wompi;
                    this.form.Payment = res.data.payment.type;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                    if (this.payment.status === 201) {
                        this.getWompi();
                    }
                    if (this.$route.query.id) {
                        this.wompiReturn()
                    }
                });
                this.timeout = setTimeout(this.getData, 150000);
            },
            getVoucher() {
                const input = this.form.Voucher;

                if (input) {
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.imageData = e.target.result;
                    };
                    reader.readAsDataURL(input);
                }
            },
            clearVoucher() {
                this.form.Voucher = null;
                this.imageData = null;
            },
            async copyText(v) {
                v = v.replace(/\D/g, '');
                try {
                    await navigator.clipboard.writeText(v);
                    this.$toast.success('Copiado Correctamente!', {icon: 'mdi-check-circle'});
                } catch (err) {
                    this.$toast.error('Error al Copiar!', {icon: 'mdi-close-circle'});
                }
            },
            getWompi() {
                if (!document.querySelector('script[src="https://checkout.wompi.co/widget.js"]')) {
                    const script = document.createElement('script');
                    script.src = 'https://checkout.wompi.co/widget.js';
                    script.setAttribute('data-render', 'button');
                    script.setAttribute('data-public-key', this.wompi.public);
                    script.setAttribute('data-currency', this.payment.currency);
                    script.setAttribute('data-amount-in-cents', parseFloat(this.payment.amount) * 100);
                    script.setAttribute('data-reference', (this.wompi.mode === 1 ? '' : 'TEST-') .this.payment.country + '-CR-' + this.payment.id);
                    script.setAttribute('data-signature:integrity', this.wompi.signature);
                    script.setAttribute('data-redirect-url', (location.origin).toString() + '/payments/' + this.payment.id);
                    script.setAttribute('data-tax-in-cents:vat', parseFloat(this.payment.tax) * 100);
                    script.setAttribute('data-customer-data:email', this.user.email);
                    script.setAttribute('data-customer-data:full-name', this.user.name + ' ' + this.user.lname);
                    script.setAttribute('data-customer-data:phone-number', this.user.phone);
                    script.setAttribute('data-customer-data:phone-number-prefix', '+57');
                    script.setAttribute('data-customer-data:legal-id', this.user.nd);
                    script.setAttribute('data-customer-data:legal-id-type', this.user.td);

                    const form = this.$refs.wompi;
                    form.appendChild(script);
                }
            },
            wompiReturn() {
                let formData = {
                    'id': this.$route.query.id,
                    'method': 'Wompi'
                };
                axios.post('/api/payments/view/' + this.id, formData).then((res) => {
                    if (res.data.v === 'success') {
                        this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                        this.$router.replace({ query: {} });
                    } else {
                        this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.getData();
                });
            },
            submit() {
                if (this.$refs.bank.validate()) {
                    this.loading = true;
                    let formData = new FormData();

                    formData.append('type', this.form.Payment);
                    formData.append('voucher',  this.form.Voucher);
                    axios.post('/api/payments/view/' + this.id, formData,
                        {headers: {'Content-Type': 'multipart/form-data'}})
                        .then((res) => {
                            if (res.data.v === 'success') {
                                this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                            } else {
                                this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                            }
                        }).catch(err => {
                            this.handleErrors(err.response.data.errors);
                        }).then(() => {
                            this.getData();
                            this.loading = false;
                        });
                }
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
